export default [
    {
		path: "/externalsignoff/:token?",
		component: () => import("../views/ExternalSignoff/View.vue"),
		meta: {
			hasmainmenu: false,
		}
	},
	{
		path: "/reports/signoff-anomalies",
		component: () => import("../views/ExternalSignoff/Anomalies.vue"),
		meta: {
			hasmainmenu: false,
		}
	}
]
